var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex h-13" }, [
    _c(
      "div",
      { staticClass: "flex pl-6 analytics-first-col-sticky bg-slate-100" },
      [
        _c(
          "div",
          {
            staticClass:
              "flex items-center border-b border-l border-r bg-pure-white border-slate-400",
            class: { "rounded-bl": _vm.isLast }
          },
          [
            _c(
              "div",
              { staticClass: "flex flex-shrink-0 w-20 px-4" },
              [
                _c("BlTextBody2", {
                  staticClass: "text-slate-1000",
                  attrs: { text: _vm.item.id }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex flex-shrink-0 px-4 w-60",
                attrs: { title: _vm.item.name }
              },
              [
                _c("BlTextBody2", {
                  staticClass: "truncate text-slate-1000",
                  attrs: { text: _vm.item.name }
                })
              ],
              1
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "flex items-center flex-shrink-0 px-4 border-b w-50 bg-pure-white border-slate-400"
      },
      [
        _c("BlTextBody2", {
          attrs: { text: _vm.item.role === "admin" ? "Admin" : "Therapist" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "flex items-center flex-shrink-0 px-4 border-b w-50 bg-pure-white border-slate-400"
      },
      [
        _c("BlChip", {
          attrs: {
            chip: _vm.statuses[_vm.item.status],
            color: _vm.statusColors[_vm.item.status]
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "flex items-center flex-shrink-0 px-4 border-b w-50 bg-pure-white border-slate-400"
      },
      [
        _c("BlTextBody2", {
          attrs: { text: _vm.displayDate(_vm.item.created_at) }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "flex items-center flex-shrink-0 px-4 border-b w-50 bg-pure-white border-slate-400"
      },
      [
        _c("BlTextBody2", {
          attrs: { text: _vm.displayDate(_vm.item.deactivated_at) }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "flex items-center flex-shrink-0 px-4 border-b w-50 bg-pure-white border-slate-400"
      },
      [
        _c("BlTextBody2", {
          attrs: { text: "" + (_vm.item.total_therapy_hours || "-") }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "flex flex-grow pr-6 analytics-last-col-sticky bg-slate-100"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "flex items-center justify-end flex-grow flex-shrink-0 w-32 px-2 border-b border-r bg-pure-white border-slate-400",
            class: { "rounded-br": _vm.isLast }
          },
          [
            _c(
              "router-link",
              {
                attrs: {
                  target: "_blank",
                  to: {
                    name: "TeamSessionHistory",
                    params: {
                      user_id: _vm.item.id,
                      redirect_target: "/analytics/team-turnover",
                      redirect_label: "Team Turnover Analytics"
                    }
                  },
                  title: "View profile"
                }
              },
              [
                _c("BlInputButton", {
                  attrs: { type: "outlined", dense: "", label: "View profile" }
                })
              ],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-516db784", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-516db784","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/table/RowTeamTurnover.vue
// module id = null
// module chunks = 